module.exports = __webpack_public_path__ + "img/New Year 6.a0bcc28b.jpeg";